<template>
  <transition name="slide-x-transition" mode="out-in">
    <section class="teacher-account-settings" v-show="ready">
      <v-container class="header" fill-height>
        <v-row class="mb-2">
          <v-col cols="12">
            <h1 class="header-title optus-highlight optus-highlight--yellow">
              Help & Support &nbsp;
            </h1>
            <v-card class="my-4">
              <v-toolbar color="primary" flat dark>
                <v-toolbar-title>FAQs</v-toolbar-title>
              </v-toolbar>
            </v-card>
            <!-- <search class="mt-3" /> -->
            <faq class="mt-3" :faqs="faqs" />
            <v-card class="my-4">
              <v-toolbar color="primary" flat dark>
                <v-toolbar-title>Submit a query</v-toolbar-title>
              </v-toolbar>
            </v-card>
            <send-question class="mt-3" :questions="questions" />
          </v-col>
        </v-row>
      </v-container>
    </section>
  </transition>
</template>

<script>
//import Search from './Search'
import Faq from '@/modules/support/views/Faq'
import SendQuestion from '@/modules/support/views/SendQuestion'
import { mapState } from 'vuex'

export default {
  name: 'Support',
  components: {
    //Search,
    Faq,
    SendQuestion
  },
  data() {
    return {
      ready: false
    }
  },
  async mounted() {
    this.$store.state.loading = true
    setTimeout(() => {
      this.ready = true
      this.$store.state.loading = false
    })
  },
  computed: {
    ...mapState(['lessonTerm']),
    questions() {
      return [
        {
          text: 'General',
          value: 'general'
        },
        {
          text: 'Class',
          value: 'class'
        },
        {
          text: `${this.capitalizeFirstLetter(this.lessonTerm)}`,
          value: 'workshop'
        },
        {
          text: 'View results and graphs',
          value: 'marks_graphs'
        },
        {
          text: 'Other',
          value: 'other'
        }
      ]
    },
    faqs() {
      return [
        {
          title: 'General',
          type: 'general',
          items: [
            {
              question: `Is there a time limit on each ${this.lessonTerm}?`,
              answer: `No. You have access to all ${this.lessonTerm}s for an unlimited time, and so do your students.`
            },
            {
              question:
                'A student has forgotten their username and/or password, what do I do?',
              answer:
                'Go to the student’s individual page through ‘manage students’. Once you are on their page you can update their username and/or password directly.'
            },
            {
              question:
                'I need to print out a Student Card, but I don’t need to print out cards for the entire class, what do I do?',
              answer:
                'Before pressing the ‘Print Student Cards’ button, you can select which student’s information you would like to print out.'
            },
            {
              question: 'How big are the student cards?',
              answer: '8 student cards can fit on a single A4 page.'
            },
            {
              question: 'I need to send my class a message, how can I do this?',
              answer:
                'In the ‘Classes’ section, use the ‘Manage & Message Class’ button to change your class details and send your class a message.'
            }
          ]
        },
        {
          title: 'Setting up and deleting a class',
          type: 'class',
          items: [
            {
              question: `How many ${this.lessonTerm}s can I assign my class?`,
              answer: `There is no limit on ${this.lessonTerm} enrolment, so you can assign your class as many or as few ${this.lessonTerm}s as you would like to.`
            },
            {
              question:
                'I’ve added in my class, but I need to add an extra student. If I click on ‘Add new student’ will I lose my original class list?',
              answer:
                'No. Students that you have enrolled in the class can only be removed from the platform if you delete them directly using their student page.'
            },
            {
              question: 'I need to change my class details, how can I do this?',
              answer:
                'In the ‘Classes’ section, use the ‘Manage & Message Class’ button to change your class details and send your class a message.'
            }
          ]
        },
        {
          title: 'Adding and deleting students',
          type: 'student',
          items: [
            {
              question: 'How do I delete a student from my class?',
              answer:
                'In the ‘Classes’ section, select which student you would like to manage. This will lead you to the student’s individual page. Once on this page, you can unenrol the student.'
            }
          ]
        },
        {
          title: 'Adding and deleting students',
          type: 'student',
          items: [
            {
              question: `I want to change the ${this.lessonTerm}s that my class can access, what do I need to do?`,
              answer: `In the ‘Classes’ section, use the ‘Manage ${this.capitalizeFirstLetter(
                this.lessonTerm
              )}s’ button to either select or deselect ${this.lessonTerm}s.`
            },
            {
              question:
                'I want to see a student’s results, where can I view them?',
              answer: `In the ‘Classes’ section, select which student you would like to manage. This will lead you to the student’s individual page. Once on this page, you can view all of the student’s results from the ${this.lessonTerm}s they have completed.`
            }
          ]
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.teacher-account-settings {
}
</style>
